import IncentiveManagement from "./IncentiveManagement.view";

export default IncentiveManagement;
